import React, { useState, useEffect  } from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { TfiArrowRight } from 'react-icons/tfi';
import './style.css' ;
import {Grid} from '@material-ui/core'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#0188CC',
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const TabelaResultado = ({ resultados }) => {
    const [showTutorial, setShowTutorial] = useState(true);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 768px)');
        setShowTutorial(mediaQuery.matches);

        const handleResize = () => {
            setShowTutorial(mediaQuery.matches);
        };

        mediaQuery.addListener(handleResize);
        return () => mediaQuery.removeListener(handleResize);
    }, []);

    const hideTutorial = () => {
        setShowTutorial(false);
      };

      return (
        <Grid className="container">
          {showTutorial && (
            <Grid className="tutorial" onClick={hideTutorial}>
              <TfiArrowRight className="arrow" />
              {/* <p>Veja mais colunas</p> */}
            </Grid>
          )}
        <TableContainer component={Paper} >
            <Table aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <StyledTableCell>Ano</StyledTableCell>
                        <StyledTableCell align="right">Projeto</StyledTableCell>
                        <StyledTableCell align="right">Doações</StyledTableCell>
                        <StyledTableCell align="right">Total</StyledTableCell>
                        <StyledTableCell align="right">Potencial</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {resultados.map((resultado, index) => (
                        <StyledTableRow key={index}>
                            <StyledTableCell align="right">{resultado.ano_}</StyledTableCell>
                            <StyledTableCell align="right">{resultado.tipo_fundo}</StyledTableCell>
                            <StyledTableCell align="right">{resultado.doacoes || '-'}</StyledTableCell>
                            <StyledTableCell align="right">{resultado.valor || '-'}</StyledTableCell>
                            <StyledTableCell align="right">{resultado.potencial6 || '-'}</StyledTableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
        </Grid>
    );
}

export default TabelaResultado;
